// extracted by mini-css-extract-plugin
export default {"root":"form-wrapper_root_DVUYc","header":"form-wrapper_header_uXaxt"};